import * as React from "react";
import styled from "styled-components";
import { GoogleAnalyticsEventType } from "../../models/google-analytics";
import * as googleAnalyticsService from "../../services/google-analytics-service";

interface HeroTextOnLeftBlockProps {
  /** TYTUŁ */
  title: string

  /** OPIS */
  description: string[]

  /** BACKGROUND IMAGE */
  backgroundImage: string

  /** GOOGLE EVENT TO TRIGGER ON SECTION VIEW */
  componentViewEventType?: GoogleAnalyticsEventType
}

interface HeroTextOnLeftBlockState {}

class HeroTextOnLeftBlock extends React.Component<HeroTextOnLeftBlockProps,HeroTextOnLeftBlockState> {

  constructor(props: HeroTextOnLeftBlockProps) {
    super(props);
    this.onComponentView = this.onComponentView.bind(this);
  }

  onComponentView() {
    if (this.props.componentViewEventType) {
      googleAnalyticsService.trackEvent(this.props.componentViewEventType);
    }
  }

  render() {
    const {title,description,backgroundImage} = this.props;
    return (
      <div className="materialize-theme-styles" onMouseEnter={this.onComponentView}>
        <HeroBlockWrapper className="parallax-bg valign-wrapper" backgroundImage={backgroundImage}>
          <div className="valign-cell">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <HeroBlockTitleWrapper className="intro-title text-capitalize">{title}</HeroBlockTitleWrapper>
                  {description.map((text: any, index: number) => {
                    return (
                      <HeroBlockTitleDescriptionWrapper className="lead" key={index}>
                        {text}
                        <br/>
                      </HeroBlockTitleDescriptionWrapper>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </HeroBlockWrapper>
      </div>
    );
  }

}

/** STYLES */

const HeroBlockWrapper: any = styled.section`
  background-image: 
    linear-gradient(
      rgba(0, 0, 0, 0.3), 
      rgba(0, 0, 0, 0.3)
    ),
    url(${(props: any) => props.backgroundImage});
  background-size: cover !important;
  background-attachment: inherit !important;
  height: 600px !important;
`;

const HeroBlockTitleWrapper = styled.h1`
  color: white;
  text-transform: initial !important;
`;

// PODTYTUŁ => P (JEDYNY H1 TO TYTUŁ), WYGLĄD JAK DOTYCHCZASOWY H1
const HeroBlockTitleDescriptionWrapper = styled.p`
  font-family: "Raleway", sans-serif !important;
  color: white;
  /* JAKO H1 MOTYW NADPISYWAŁ 600 NA 300 => ZOSTAWIAMY 300 */
  font-weight: 300 !important;
  margin-bottom: 0px !important;
`;

export default HeroTextOnLeftBlock;


// WEBPACK FOOTER //
// ./src/layouts/hero-text-on-left-block/hero-text-on-left-block.tsx